import React, { useState } from 'react';
import { Box, Button } from 'grommet';
import { useKeenSlider } from "keen-slider/react";
import "keen-slider/keen-slider.min.css";
import FadeInInductee from './utility/FadeInInductee'; // Check your path

// --- Helper Arrow Component ---
function Arrow(props) {
  const disabled = props.disabled ? " arrow--disabled" : "";
  return (
    <svg
      onClick={props.onClick}
      className={`arrow ${
        props.left ? "arrow--left" : "arrow--right"
      } ${disabled}`}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
    >
      {props.left && (
        <path d="M16.67 0l2.83 2.829-9.339 9.175 9.339 9.167-2.83 2.829-12.17-11.996z" />
      )}
      {!props.left && (
        <path d="M5 3l3.057-3 11.943 12-11.943 12-3.057-3 9-9z" />
      )}
    </svg>
  );
}

const InducteeSlider = ({ category, t, onInducteeClick }) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [loaded, setLoaded] = useState(false);

  const getSliderOrigin = () => {
    // Calculate window width and determine 
    // how much is 1px in percentage
    const windowWidth = window.innerWidth;
    const onePxInPercent = 100 / windowWidth;
    return 30 * onePxInPercent / 100; // 30px from left

  }

  // Initialize Keen Slider
  // We destructure [sliderRef, instanceRef] so we can attach the ref to the DOM
  // and use the instance to call .next() / .prev()
  const [sliderRef, instanceRef] = useKeenSlider({
    slides: {
      perView: 1.25,
      spacing: 15,
      origin: getSliderOrigin(),
    },
    breakpoints: {
      '(min-width: 768px)': {
        slides: {
          perView: 1.75,
          spacing: 15,
          origin: getSliderOrigin(),
        }
      },
      '(min-width: 992px)': {
        slides: {
          perView: 2.5,
          spacing: 15,
          origin: getSliderOrigin(),
        }
      },
      '(min-width: 1200px)': {
        slides: {
          perView: 3.5,
          spacing: 15,
          origin: getSliderOrigin(),
        }
      },
    },
    initial: 0,
    slideChanged(slider) {
      setCurrentSlide(slider.track.details.rel);
    },
    created() {
      setLoaded(true);
    },
  });

  // --- Render Helpers ---

  const renderHeaderCategoryImage = () => {
    if (category?.fields?.image) {
      return (
        <img
          className="museum__category__header__image"
          alt={category.fields.name}
          src={category.fields.image.fields.file.url}
        />
      );
    }
    return null;
  };

  const renderHeaderCategorySubheader = (category) => {
    if (
      category.hasOwnProperty('fields')
      && category.fields.hasOwnProperty('shortDescription')
    ){
      return (
        <div className="museum__category__header__subheader bigText">
          <p>{category.fields.shortDescription}</p>
        </div>
      )
    }
  }

  const renderCategoryImage = () => {
    if (category?.fields?.image) {
      return (
        <img
          key="cat-img"
          className="museum__category__winner__category-image"
          alt={category.fields.name}
          src={category.fields.image.fields.file.url}
        />
      );
    }
    return null;
  };

  const renderInducteeImage = (winner) => {
    if (winner.fields?.product?.fields?.image) {
      return (
        <img
          className="inducteeImage"
          src={winner.fields.product.fields.image.fields.file.url}
          alt={winner.fields.product.fields.name || 'Inductee'}
        />
      );
    }
    return <p>No inductee image</p>;
  };

  const renderYearText = (winner) => (
    <div key="year-txt" className="museum__category__winner__text">
      {/*
      <div className="museum__category__winner__text__year">
        {winner.fields.year}
      </div>
      */}
      <div className="museum__category__winner__text__winner">
        {t("WINNER")}
      </div>
    </div>
  );

  const renderArrows = () => {
      {/* Arrows (Only render if slider is loaded) */}
      if (loaded && instanceRef.current) {

      // Calculate Limits
      // minIdx is usually 0
      // maxIdx is the last possible scroll position (accounting for perView)
      const minIdx = instanceRef.current.track.details.minIdx;
      const maxIdx = instanceRef.current.track.details.maxIdx;

      // Determine Disabled States
      const leftDisabled = currentSlide === minIdx;
      const rightDisabled = currentSlide === maxIdx;

        return (
          <div className="museum__category__arrows">
            <div
              className={"museum__category__arrows__arrow  museum__category__arrows__arrow--left" + (leftDisabled ? " museum__category__arrows__arrow--disabled" : "")}
              onClick={(e) =>
                e.stopPropagation() || instanceRef.current?.prev()
              }
              disabled={leftDisabled}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="25" fill="none" viewBox="0 0 14 25" > <path fill="#0B002B" d="M13.27 10.839a1.724 1.724 0 0 1 0 2.437L2.941 23.605a1.724 1.724 0 0 1-2.437-2.437l9.114-9.113L.51 2.94A1.724 1.724 0 0 1 2.947.504l10.329 10.33z" ></path> </svg>
            </div>

            <div
              className={"museum__category__arrows__arrow  museum__category__arrows__arrow--right" + (rightDisabled ? " museum__category__arrows__arrow--disabled" : "")}
              onClick={(e) =>
                e.stopPropagation() || instanceRef.current?.next()
              }
              disabled={rightDisabled}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="25" fill="none" viewBox="0 0 14 25" > <path fill="#0B002B" d="M13.27 10.839a1.724 1.724 0 0 1 0 2.437L2.941 23.605a1.724 1.724 0 0 1-2.437-2.437l9.114-9.113L.51 2.94A1.724 1.724 0 0 1 2.947.504l10.329 10.33z" ></path> </svg>
          </div>
          </div>
        )
      }
  }

  return (
    <Box className="museum__category">
      
      {/* Category Header */}
      <div className="museum__category__header">
        <div className="museum__category__header__divider"></div>
        {renderHeaderCategoryImage()}
        <div className="museum__category__header__divider"></div>
      </div>
      {renderHeaderCategorySubheader(category)}

      <div className="museum__category__slider-wrapper">
        {renderArrows()}

        {/* The Slider */}
        <div ref={sliderRef} className="keen-slider museum__category__winners">
          {category.fields.inductees.map((winner) => (
            <div
              key={winner.fields.year}
              className="keen-slider__slide museum__category__winner"
            >
              <FadeInInductee
                className="inducteeSlide"
                animate={false}
                delay={0}
                calcBasis={() => ""}
                extra={[
                  renderCategoryImage(),
                  renderYearText(winner)
                ]}
                onClick={() => onInducteeClick(category, winner)}
              >
                {renderInducteeImage(winner)}
                
                <div className="inducteeContent">
                  <div className="inducteeContentWrapper">
                    <Box className="textWrapper">
                      {winner.fields?.product?.fields?.name && (
                        <h3>{winner.fields.product.fields.name}</h3>
                      )}
                      {winner.fields?.product?.fields?.shortDescription && (
                        <p className="shortDescription">
                          {winner.fields.product.fields.shortDescription}
                        </p>
                      )}
                    </Box>

                    <Box className="buttonWrapper inducteeButtonContainer">
                      <Button
                        primary
                        label={t("Learn more")}
                        fill="horizontal"
                        focusIndicator={false}
                        hoverIndicator={false}
                      />
                    </Box>
                  </div>
                </div>
              </FadeInInductee>
            </div>
          ))}
        </div>
      </div>

    </Box>
  );
};

export default InducteeSlider;
